import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pollution-liability',
  templateUrl: './pollution-liability.component.html',
  styleUrls: ['./pollution-liability.component.scss']
})
export class PollutionLiabilityComponent implements OnInit {
  summaryPanel;
  get summaryAPIData() {
    return this.summaryPanel;
  }
  @Input() set summaryAPIData(value) {
    this.summaryPanel = { ...value };
  }
  @Input() summarySitecoreData;
  @Input() pageName;
  summaryContent;
  constructor() {}

  ngOnInit(): void {
    this.summaryContent = this.summarySitecoreData;
    window.scrollTo(0, 0);
  }
}
